import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TrackedIconButton as IconButton } from '../../components/TrackedComponents';

interface OpenInMobileDialogProps {
    open: boolean;
    onClose: () => void;
}

const OpenInMobileDialog: React.FC<OpenInMobileDialogProps> = (props: OpenInMobileDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            id="open-in-mobile-dialog"
            data-testid="open-in-mobile-dialog"
            open={props.open}
            onClose={() => props.onClose()}
        >
            <Box
                sx={{
                    backgroundColor: 'secondary.main',
                    position: 'sticky',
                    top: 0,
                    p: 1,
                    zIndex: 2,
                }}
            >
                <Box sx={{ position: 'absolute', display: 'flex', right: 4, top: 4 }}>
                    <IconButton id="btn-close-modal" size="small" onClick={() => props.onClose()}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', height: '24px' }}>
                    <Typography>{t('login.open_in_mobile.header')}</Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '250px', p: 1 }}>
                <Typography fontSize={14} sx={{ mb: 1 }}>
                    {t('login.open_in_mobile.instructions')}
                </Typography>
                <QRCodeSVG value={window.location.href} size={234} />
            </Box>
        </Dialog>
    );
};

export default OpenInMobileDialog;
